const EthereumCnt = {
  symbol: "ETH",
  name: "ethereum",
  meta: {
    title: "Buy ethereum | Buy ethereum | Ethereum prices and charts",
    description:
      "ethereum is the second largest cryptocurrency in the world and has many fans. Buy and sell ethereum at the best price, lowest price and fastest time in coinnik Market",
    keywords: "ethereum, ethereum Buy, ethereum Sell, ethereum Price",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "چگونه کاردانو بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید  کادرانو کنید.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول کاردانو کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " کیف پول رسمی کاردانو، دایدالوس (Deadalus) است که نام آن بر اساس یکی از مشهور‌ترین معماران و مخترعین افسانه‌های یونانی گرفته شده است. این کیف پول توسط IOHK توسعه یافته و اجازه می‌دهد یک نسخه کامل از بلاک چین کاردانو را روی سیستم خود دانلود و به شکل مستقل تمامی تراکنش‌های این شبکه را تایید کنید. این ویژگی اجازه می‌دهد تا به حداکثر امنیت شبکه دست پیدا کنید و از سرورهای متمرکز خارجی خبری نباشد. دیگر کیف پول‌هایی که از کاردانو پشتیبانی می‌کنند عبارتند از: کیف پول یوروی (Yoroi)، کیف پول اکسودوس (Exodus)، کیف پول تراست (Trust)، کیف پول لجر (Ledger) و کیف پول ترزور (Trezur) و کیف پول کوین نیک مارکت.",
        },
      },
      {
        "@type": "Question",
        name: " آیا می‌توان کاردانو را در کوین نیک مارکت نگهداری کرد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در کوین‌نیک مارکت یک کیف پول اختصاصی و امن دارید، که می‌توانید رمزارزهیاتان را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت.",
        },
      },
      {
        "@type": "Question",
        name: "آیا کاردانو ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " سرمایه‌گذاران و تریدرها به رشد کاردانو و ارزش پیش‌بینی شده آن اتفاق نظر دارند. کاردانو پس از سال‌ها ثبات قیمت، آماده است تا یک بار دیگر قیمت خود را افزایش داده و پتانسیل واقعی خود را نشان دهد. همچنین، کاردانو بسیار جدید است، به این معنی که سرمایه‌گذاران هنوز فرصت دارند تا در میان معدود افرادی قرار بگیرند که بیشترین رشد اقتصادی را تجربه می‌کنند. کاردانو در مقایسه با بسیاری دیگر ارز رمزها دیر به این بازار وارد شد، اما این دارایی دیجیتال سرشار از نوآوری است و همین موضوع به رشد چشمگیر و باور نکردنی قیمت آن دامن می‌زند. پتانسیل کاردانو اگر بیش از قبل نباشد، هنوز بسیار بالا است.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy ethereum?",
      answer:
        "In coinnik Market trading market, you can buy ethereum with Shetab member bank card and the lowest fee. The price of Atrium in Quinnic Market is determined by you.",
      id: "toggler1",
    },
    {
      question: "What is the best ethereum wallet?",
      answer: "ethereum_wallet",
      id: "toggler2",
    },
    {
      question: "Can ethereum be kept at Coinnik Market?",
      answer:
        "You have a dedicated and secure wallet in Quinnik Market, where you can store your cryptocurrencies, including Atrium. In this case, you will no longer have any worries and stress about the freezing of your balance in foreign exchange offices due to financial sanctions against Iran.",
      id: "toggler3",
    },
    {
      question: "Is ethereum Worth the Investment?",
      answer: "ethereum_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about ethereum",
        subTitle: "What is an ethereum?",
        content: "ethereum_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of ethereum",
        content: "ethereum_history_description",
        btnTitle: "Buy and sell ethereum Coin",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle:
          "Buy and sell ethereum without intermediaries in coinnik Market",
        subTitle: "Buy ethereum Coin",
        content: "Buy_ethereum_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sale ethereum",
        content: "sale_ethereum_description",
        btnTitle: "Buy and sell ethereum Coin",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest ethereum analysis on the blog",
  informationTitle: "ethereum market statistics and information",
};

export default EthereumCnt;
